'use client';
import parse from 'html-react-parser';

export default function Template(Prop: {moduleOption: any}) {
  const options = Prop.moduleOption || {};
  const templateItems = options?.items || [];

  const formTemplate = (templateItem: any) => {
    let template = options?.template ?? '';
    Object.entries(templateItem).forEach(([key, value]) => {
      template = template.replaceAll(`{${key}}`, value);
    });
    return parse(template);
  };

  return (
    <div className={options?.class}>
      {templateItems.map((templateItem: any, index: number) => (
        <div key={index}>{formTemplate(templateItem)}</div>
      ))}
    </div>
  );
}
